export default __webpack_public_path__ + "static/media/pin-outline.7597572d.svg";